import { GlobalContext } from "@/context/globalContext";
import React, { useContext } from "react";

const BgShadow = () => {
  const { bgShadow, setBgShadow } = useContext(GlobalContext);
  if (bgShadow)
    return (
      <div
        className="fixed z-50 bg-black bg-opacity-70 w-screen  inset-0 h-screen "
        onClick={() => {
          setBgShadow(false);
        }}
      ></div>
    );
};

export default BgShadow;
